import { render, staticRenderFns } from "./food.vue?vue&type=template&id=d2a178f6&scoped=true"
import script from "./food.vue?vue&type=script&lang=js"
export * from "./food.vue?vue&type=script&lang=js"
import style0 from "./food.vue?vue&type=style&index=0&id=d2a178f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a178f6",
  null
  
)

export default component.exports